// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"LapuSimMasterPage_inputContainer__WZFMY","headerActions":"LapuSimMasterPage_headerActions__C-fpb"};